import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import { ArrowRight } from "lucide-react";

const INTERIOR_IMG =
  "https://static.prod-images.emergentagent.com/jobs/3c0dfd58-edf3-43de-94bb-9a0fc30d9282/images/4cf9b20fe65219f92a22c72831899dee712d185fa86498ad6b5fe6160286efa5.png";

const About = () => {
  const { t } = useI18n();
  return (
    <div data-testid="about-page">
      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <p className="text-label text-[#FFB400]">
          <span className="line-accent" />
          {t.about.eyebrow}
        </p>
        <h1 className="mt-4 font-heading text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tighter text-white max-w-4xl" data-testid="about-title">
          {t.about.title}
        </h1>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5 relative aspect-[4/5] overflow-hidden border border-white/10 bg-[#0a0a0a]">
            <img src={INTERIOR_IMG} alt="Luxury interior" className="w-full h-full object-cover" />
          </div>
          <div className="lg:col-span-7 space-y-6 text-zinc-300 text-lg leading-relaxed">
            <p>{t.about.p1}</p>
            <p>{t.about.p2}</p>
            <Link to="/contact" className="btn-primary inline-flex mt-4" data-testid="about-cta-contact">
              {t.nav.contact} <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>

      <section className="border-y border-white/10 bg-[#080808]" data-testid="stats-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 grid grid-cols-2 md:grid-cols-4 gap-10">
          {t.about.stats.map((s, i) => (
            <div key={i} className="text-center md:text-left">
              <p className="font-heading text-5xl sm:text-6xl font-bold tracking-tighter text-white">
                {s.v}
              </p>
              <p className="mt-2 text-label">{s.l}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-24">
        <p className="text-label text-[#FFB400]"><span className="line-accent" />Everett, MA</p>
        <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-white">
          Find us in Everett, minutes from Logan.
        </h2>
        <div className="mt-10 aspect-[16/8] border border-white/10 overflow-hidden" data-testid="boston-map">
          <iframe
            title="Movix Everett Map"
            className="w-full h-full"
            style={{ filter: "invert(0.92) hue-rotate(180deg) saturate(0.6) brightness(0.95)" }}
            src="https://www.openstreetmap.org/export/embed.html?bbox=-71.0700%2C42.4000%2C-71.0380%2C42.4180&layer=mapnik&marker=42.4084%2C-71.0537"
          />
        </div>
        <p className="mt-6 text-zinc-400">{t.contact.address} · {t.contact.hours}</p>
      </section>
    </div>
  );
};

export default About;
